import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import PlayView from './play/PlayView';
import type { Round } from './data/types';
import './styles/tokens.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

/* The offline export: one downloaded file that plays with no network.
 *
 * The exported HTML inlines this very bundle and leaves the round on the window, so what plays
 * is the REAL play surface rather than a second copy of it that would drift. See
 * rounds/offlineExport.ts.
 *
 * Handled here, ABOVE the router, deliberately. The file opens from `file://`, where the
 * pathname is something like /Users/…/series-1-offline.html and no basename matches — a
 * BrowserRouter would resolve to nothing and render a blank page on a shoot. Rendering PlayView
 * directly sidesteps routing entirely, which is only sound because the play surface imports
 * nothing from react-router. */
const offlineRound = (window as unknown as { __ROF_OFFLINE_ROUND__?: Round }).__ROF_OFFLINE_ROUND__;
if (offlineRound) {
  createRoot(root).render(
    <StrictMode>
      <PlayView round={offlineRound} />
    </StrictMode>,
  );
} else {
createRoot(root).render(
  <StrictMode>
    {/* basename matches vite.config.ts `base` — the app is served from a path on the apex,
        not from a domain root like the other CORE apps. */}
    <BrowserRouter basename="/real-or-fake">
      <App />
    </BrowserRouter>
  </StrictMode>,
);
}
